import { render, staticRenderFns } from "./ATInstruction.vue?vue&type=template&id=c3333542&scoped=true&"
import script from "./ATInstruction.vue?vue&type=script&lang=js&"
export * from "./ATInstruction.vue?vue&type=script&lang=js&"
import style0 from "./ATInstruction.vue?vue&type=style&index=0&id=c3333542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3333542",
  null
  
)

export default component.exports